import { filter, of, tap } from 'rxjs';

import { StorageService, TILE_TRANSITION_CONDITIONS, TileTransitionCondition, TileTransitionPhase } from '@contact/upgrade';

function CleanWallbaordAutoLoginResolver(storageService: StorageService): TileTransitionCondition {
  return transition =>
    of(transition).pipe(
      filter(({ phase }) => phase === TileTransitionPhase.RESOLVER),
      filter(({ to }) => !to),
      tap(() => storageService.remove('wallboardAutoLogin', false))
    );
}

const CleanWallbaordAutoLoginResolverProvider = {
  provide: TILE_TRANSITION_CONDITIONS,
  useFactory: CleanWallbaordAutoLoginResolver,
  deps: [StorageService],
  multi: true,
};

export const WALLBOARD_GUARDS = [CleanWallbaordAutoLoginResolverProvider];
